// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__9Z+TO","fadeIn":"styles_fadeIn__rTyjJ","lds-spinner":"styles_lds-spinner__cO9Ix"};